export default __webpack_public_path__ + "static/media/baihe.6bfbe447.jpeg";